/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar, Checkbox, Image, Popover, Space, Tag, Typography } from "antd";
import { useState } from "react";
// import PopOverCardSchedule from "../KanbanBoard/PopOverCardSchedule";

interface VisitExtendedProps {
  type:
    | "visit"
    | "drive"
    | "crew-yard-start"
    | "crew-yard-end"
    | "weekend-bg"
    | "drive-loading";
  durationMinutes?: number;
  driveTimeMinutes?: string;
  driveTimeSeconds?: number;
  location?: string;
  nextVisitLocation?: string;
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
  workOrders?: string[];
  homeIcon?: string;
  status?: string;
  company_id?: string;
  crewId?: string;
  contract_name?: string;
  crew_or_contractor_name?: string;
  crew_leader_name?: string;
  property_address?: string;
}

export default function RenderEventContentSchedule({
  eventInfo,
  // setLoading,
  setSelectedVisitIds,
  selectedVisitIds,
}: any) {
  const [openDetailPopup, setOpenDetailPopUp] = useState<boolean>(false);
  const handleOpenChange = (newOpen: boolean) => {
    setOpenDetailPopUp(newOpen);
  };
  const event = eventInfo.event;
  const customProps = event.extendedProps as VisitExtendedProps;
  const isDriveEvent = customProps.type === "drive";
  const crewYardStart = customProps.type === "crew-yard-start";
  const crewYardEnd = customProps.type === "crew-yard-end";
  const weekendBg = customProps.type === "weekend-bg";
  const driveLoader = customProps.type === "drive-loading";

  // console.log("driveLoader-------------------------", driveLoader);
  // console.log("customProps---", customProps);

  let durationText = "";
  let driveTimeSeconds = 0;
  if (isDriveEvent) {
    if (customProps.driveTimeMinutes !== undefined) {
      const totalMinutes = customProps.driveTimeMinutes;
      durationText = totalMinutes;
    }
    if (customProps?.driveTimeSeconds && customProps?.driveTimeSeconds > 0) {
      driveTimeSeconds = customProps?.driveTimeSeconds || 0;
    }
  }
  if (isDriveEvent && driveTimeSeconds < 500) return null;

  const now = new Date();
  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );
  const eventDate =
    event?.start instanceof Date
      ? new Date(
          event.start.getFullYear(),
          event.start.getMonth(),
          event.start.getDate()
        )
      : startOfToday;
  const isTodayOrFuture = eventDate >= startOfToday;
  return (
    <>
      {event.title === "Day off" && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "calc(100% - 40px)",
            flexDirection: "column",
            background: "#fff",
            border: "1px solid #EFF2F3",
            margin: "8px 22px",
            padding: "16px",
            borderRadius: "10px",
          }}
        >
          <Typography.Text
            strong
            style={{
              color: "#151718",
              lineHeight: "16px",
              fontSize: "12px",
              fontWeight: "500",
              marginBottom: "6px",
            }}
          >
            {event.title}
          </Typography.Text>

          <Typography.Text
            style={{
              color: "#151718",
              lineHeight: "16px",
              fontSize: "12px",
              fontWeight: "400",
            }}
          >
            No visits planned
          </Typography.Text>
        </div>
      )}

      {isDriveEvent && (
        <div className="driveEventContent">
          <Space size={4}>
            <Typography.Text style={{ fontSize: "12px", color: "#424647" }}>
              {durationText} drive
            </Typography.Text>
          </Space>
        </div>
      )}

      {crewYardStart && (
        <div
          className={
            isTodayOrFuture
              ? "crewYardContent future_calendar_card"
              : "crewYardContent"
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <img
              src="/images/schedule/icon-home.svg"
              alt="Home Icon"
              style={{
                width: "14px",
                height: "14px",
                marginRight: "5px",
              }}
            />
            <Typography.Text
              strong
              style={{
                color: "#151718",
                lineHeight: "normal",
                fontSize: "14px",
                fontWeight: "600",
                marginTop: "4px",
              }}
            >
              {event.title}
            </Typography.Text>
          </div>
        </div>
      )}

      {crewYardEnd && (
        <div
          className={
            isTodayOrFuture
              ? "crewYardContent future_calendar_card"
              : "crewYardContent"
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <img
              src="/images/schedule/icon-home.svg"
              alt="Home Icon"
              style={{
                width: "14px",
                height: "14px",
                marginRight: "5px",
              }}
            />
            <Typography.Text
              strong
              style={{
                color: "#151718",
                lineHeight: "normal",
                fontSize: "14px",
                fontWeight: "600",
                marginTop: "4px",
              }}
            >
              {event.title}
            </Typography.Text>
          </div>
        </div>
      )}

      {driveLoader && (
        <div className="driveEventContent2">
          <Space size={4}>
            <Typography.Text style={{ fontSize: "18px", color: "#424647" }}>
              Calculating drive time...
            </Typography.Text>
          </Space>
        </div>
      )}

      {!isDriveEvent &&
        !crewYardStart &&
        !crewYardEnd &&
        !weekendBg &&
        !driveLoader && (
          <div
            className={[
              "visitEventContent",
              isTodayOrFuture ? "future_calendar_card" : "",
              customProps.status === "IN_PROGRESS" ? "visit_in_progress" : null,
              selectedVisitIds.includes(String(event.id ?? ""))
                ? "checked_event"
                : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            <div className="fc-event-main-frame" style={{ width: "100%" }}>
              <Popover
                arrow={false}
                content={
                  <div className="unschedule_property_detail">
                    <div className="detail_header">
                      <h3>{event.title}</h3>
                    </div>
                    <div className="visitAddress">
                      <div className="visitWrapper">
                        <div className="visitTiming">
                          <label>Contract:</label>
                          <h4>{customProps?.contract_name}</h4>
                        </div>
                        <div className="visitTiming">
                          <label>Crew:</label>
                          <Tag className="default-tag">
                            {customProps?.crew_or_contractor_name}
                            {customProps?.crew_leader_name
                              ? " - " + customProps?.crew_leader_name
                              : ""}{" "}
                          </Tag>
                        </div>
                      </div>

                      <div className="addressImage">
                        <Avatar
                          size={40}
                          src={
                            event?.property?.image_url ||
                            "/images/company/no_image_grey.png"
                          }
                        />
                        <div className="addressInfo">
                          <h5>{event?.property_name}</h5>
                          <div className="addressLabel">
                            <Image
                              src="/images/estimate/address-icon.svg"
                              preview={false}
                              width={12}
                            />
                            <p>{customProps?.property_address}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                trigger="click"
                open={openDetailPopup}
                onOpenChange={handleOpenChange}
                placement="rightTop"
                // getPopupContainer={(trigger) =>
                //   trigger.parentElement || document.body
                // }
              >
                <div
                  className="event-select-checkbox"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginBottom: 6,
                  }}
                >
                  <Checkbox
                    aria-label="Select event"
                    onClick={(e) => e.stopPropagation()}
                    checked={selectedVisitIds.includes(String(event.id ?? ""))}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      const id = String(event.id ?? "");
                      window.dispatchEvent(
                        new CustomEvent("schedule:eventSelectionChange", {
                          detail: { id, checked },
                        })
                      );
                      setSelectedVisitIds((prevIds: string[]) =>
                        checked
                          ? [...prevIds, id]
                          : prevIds.filter((prevId) => prevId !== id)
                      );
                    }}
                    style={{ zIndex: 9, marginTop: -8 }}
                  />
                  <div className="shadow_checkbox2" />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    color: "#151718",
                    lineHeight: "20px",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  <Typography.Text
                    strong
                    style={{
                      color: "#151718",
                      lineHeight: "16px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    {event.title}
                  </Typography.Text>
                </div>
                {customProps?.workOrders &&
                  customProps.workOrders.length > 0 && (
                    <ul
                      className="workOrdersList"
                      style={{ paddingLeft: "18px", marginTop: "6px" }}
                    >
                      {customProps.workOrders.map((workOrder: any, index) => (
                        <li
                          key={index}
                          style={{
                            color: "#151718",
                            fontSize: "12px",
                            lineHeight: "16px",
                            fontWeight: "400",
                            listStyleType: "disc",
                            marginBottom: "2px",
                          }}
                        >
                          {workOrder.name}
                        </li>
                      ))}
                    </ul>
                  )}
              </Popover>
            </div>
          </div>
        )}
      {/* {<div
          className={
            isDriveEvent
              ? "driveEventContent"
              : customProps.status === "IN_PROGRESS"
              ? "visitEventContent visit_in_progress"
              : crewYard
              ? "crewYardContent"
              : "visitEventContent"
          }
        >
          {isDriveEvent ? (
            <Space size={4}>
              <Typography.Text style={{ fontSize: "12px", color: "#424647" }}>
                {durationText} drive
              </Typography.Text>
            </Space>
          ) : crewYard ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <img
                src="/images/schedule/icon-home.svg"
                alt="Home Icon"
                style={{
                  width: "14px",
                  height: "14px",
                  marginRight: "4px",
                }}
              />
              <Typography.Text
                strong
                style={{
                  color: "#151718",
                  lineHeight: "20px",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {event.title}
              </Typography.Text>
            </div>
          ) : (
            <div className="fc-event-main-frame" style={{ width: "100%" }}>
              <Popover
                title={
                  <PopOverCard
                    visitData={customProps}
                    crewId={customProps?.crewId}
                    companyId={customProps?.company_id}
                    setLoading={setLoading}
                  />
                }
                placement="right"
                arrow={false}
                trigger={"click"}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  <Typography.Text
                    strong
                    style={{
                      color: "#151718",
                      lineHeight: "16px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    {event.title}
                  </Typography.Text>
                </div>
                {customProps?.workOrders &&
                  customProps.workOrders.length > 0 && (
                    <ul
                      className="workOrdersList"
                      style={{ paddingLeft: "18px", marginTop: "6px" }}
                    >
                      {customProps.workOrders.map((workOrder: any, index) => (
                        <li
                          key={index}
                          style={{
                            color: "#151718",
                            fontSize: "12px",
                            lineHeight: "16px",
                            fontWeight: "400",
                            listStyleType: "disc",
                            marginBottom: "2px",
                          }}
                        >
                          {workOrder.name}
                        </li>
                      ))}
                    </ul>
                  )}
              </Popover>
            </div>
          )}
        </div>} */}
    </>
  );
}
